import Vue from 'vue'
import Router from 'vue-router'
import Survey from '@/components/survey.vue';
import Questions from '@/components/Questions.vue';
import FrontPage from '@/components/frontpage.vue';
import Result from '@/components/result.vue';
import Rapport from '@/components/rapport.vue';
import PermissionEmail from '@/components/permissionEmail.vue';
import PermissionPhone from '@/components/permissionPhone.vue';

// Extended surveyid
import ExtendedSurvey from '@/components/extended/extended-survey.vue';
import ExtendedQuestions from '@/components/extended/extended-questions.vue';
import ExtendedBefore from '@/components/extended/extended-before-start.vue';
import ExtendedRapport from '@/components/extended/extended-rapport.vue';
import ExtendedResult from '@/components/extended/extended-result.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'FrontPage',
      component: FrontPage
    },
    {
      path: '/survey/:survey',
      name: 'Survey',
      component: Survey
    },
    {
      path: '/survey/:survey/c/:c/q/:q',
      name: 'Questions',
      component: Questions
    },
    {
      path: '/resultat/:survey',
      name: 'Result',
      component: Result
    },
    /*
    {
      path: '/permission-email/:surveyid',
      name: 'PermissionEmail',
      component: PermissionEmail
    },
    {
      path: '/permission-phone/:surveyid',
      name: 'PermissionPhone',
      component: PermissionPhone
    },
    */
    {
      path: '/rapport/:survey/:rapportid',
      name: 'Rapport',
      component: Rapport
    },
    { // Extended flow comes here
      path: '/survey/v2/:survey',
      name: 'ExtendedSurvey',
      component: ExtendedSurvey
    },
    {
      path: '/survey/v2/:survey/c/:c/q/:q',
      name: 'ExtendedQuestions',
      component: ExtendedQuestions
    },
    {
      path: '/survey/v2/:survey/before',
      name: 'ExtendedBefore',
      component: ExtendedBefore
    },
    {
      path: '/v2/resultat/:survey',
      name: 'ExtendedResult',
      component: ExtendedResult
    },
    {
      path: '/v2/rapport/:survey/:rapportid',
      name: 'ExtendedRapport',
      component: ExtendedRapport
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js